import React from 'react'
import Library from './Library'
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import ShareIcon from '@material-ui/icons/Share';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import BookmarkBorderOutlinedIcon from '@material-ui/icons/BookmarkBorderOutlined';
import ReportOutlinedIcon from '@material-ui/icons/ReportOutlined';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { withStyles } from '@material-ui/core/styles';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import profile from '../../../../img/profile.jpeg'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import bannerLogo from '../../../../img/logo.png'
import '../../../QnA/QnA.css'
import './Library.css'
import { useEffect, useState } from 'react'

import UrlCard from '../../Post/UrlCard'
import './Library.css'



function BookPdf() {
    const [data, setData] = useState([]);
    useEffect(() => {
        fetch("https://recruitingmonk-v2.azurewebsites.net/library/alllibrary", {

        })

            .then((res) => res.json())
            .then((result) => {
                console.log(result);
                if(result.success)
                    setData(result.library);

            }).catch((err) => {
                console.log(err)
            })
    }, []);
    return (
        <div className="LibCards">
            <Library content='Articles' />
            <div className="Cards">
                {data.map((item) => {
                    return <UrlCard key={item._id} title={item.text} author={`Contributor: ${item.name}`} comments={item.comments.length} views="45" votes={item.likes.length} className="card" />
                })}

            </div>
        </div>
    )
}

export default BookPdf



